/**
 * **************************************************************************************************************
 * Allgemeine Schnittstellenfunktionen als Query-Plugin für die Nutzung von GDA-Wasser-Karten in Fachanwendungen
 * **************************************************************************************************************
 * Die vorliegende Datei gdaClient.jsx hat Charakter einer Bibliothek und sollte NICHT EDITIERT WERDEN,
 * um zukünftige Updates der Bibliothek zu ermöglichen.
 * Der Fachanwendungs-spezifische Code (Brücke zwischen dieser API und der Fachanwendung) wird in einer seperaten Datei im Projekt definiert.
 * VORAUSSETZUNGEN:
 * - die Javascript Bibliotheken müssen in einem gemeinsamen Ordner liegen
 * -- gda_common.js
 * -- easyXDM.min.js
 * - auf der aufrufenden Seite muss jQuery eingebunden sein
 * - auf der aufrufenden Seite muss die Konfiguration für sie Schnittstelle definiert werden:
 * -- externalBaseURL = 'http://213.139.159.36/GDAWasser/client/xdm/' -> Basis URL zu GDA Wasser, aus Property-Datei
 * -- externalApplicationId = 11111; -> Application ID der zu verwendenen GDA-Instanz
 * -- dspfUserId = 7756; -> User-ID des DSPF-Users für den GDA-Login
 * -- datascoutBaseURL = 'http://www.datascout.rlp.de/'
 * mehr Infos finden sich in der Doku
 */
import jQuery from "jquery";
import easyXDM from "easyxdm";
import _ from "lodash";
import {logger} from "../../services/LogService";

const gdaClient = function (callback, settings, modus) {
    const gdaBaseUrl = process.env.REACT_APP_GDA_BASE_URL;
    const gdaApplicationId_l = process.env.REACT_APP_GDA_APPLICATION_ID_L;
    const gdaApplicationId_s = process.env.REACT_APP_GDA_APPLICATION_ID_S;

    let gdaProxy = null;
    let gdaPoupWindow = null;
    //GDA XDM Funktions-Queue - onReady
    let functionQueueWaitForReady = [];
    let gisReadyTimer = null;
    let isLoaded = false;

    let config = {
        recieveCoordinate: function () {
        },
        externalBaseUrl: "" + gdaBaseUrl + "/GDAWasser/client/xdm/",// "http://213.139.159.36/GDAWasser/client/xdm/", //Default für Live Umgebung GDA Wasser
        externalApplicationId: !modus || modus === "l" ? gdaApplicationId_l : gdaApplicationId_s,
        dspfUserId: "10590",
        datascoutBaseURL: "https://datascout.rlp-umwelt.de", //Default für Live Umgebung Datascout
        winOpts: "width=900, height=600, resizable=yes", //Default
        confirm: null,
    };

    if (settings) {
        _.merge(config, settings);
    }

    /* Methods for common GDA API functions */

    /* Methode zum Editieren einer Punkt-Koordinate.
     * Die Koordinate wird Fachobjkekt-unabhängig in GDA editiert (verschoben) oder neu gesetzt (beim Aufruf mitNULL als Rechtswert/Hochwert)
     * Die Speicherung der Koordinate erfolgt nicht über GDA Wasser, sondern die Koordinate wird beim Schließen an die Fachanwednung
     * zurück übergeben. Hierfür muss zusätzlich die Methode "recieveCoordinate" lokal implementiert werden, die die Koordinate
     * entgegennimmt und verarbeitet
     **/
    const editCoordinate = async function (rechtswert, hochwert) {
        await openGDAPopup();

        let coordinate = null;
        let boundingBox = null;
        if (rechtswert != null && hochwert != null) {
            coordinate = [rechtswert, hochwert];
            boundingBox = [rechtswert - 100, hochwert - 30, rechtswert + 100, hochwert + 30];
        }

        sendGDARequestWhenReady(function () {
            gdaProxy.postMessage({
                action: "createOrEditCoordinate",
                coord: coordinate,
            });
        });

        sendGDARequestWhenReady(function () {
            if (coordinate != null) {
                logger.debug(boundingBox);
                gdaProxy.postMessage({
                    action: "zoomTo",
                    obj: boundingBox,
                });
            }
        });
    };

    /* Methode zum Editieren einer Geometrie.
     * Die Geometrie wird gehighlightet und kann in GDA Wasser bearbeitet und via WFST gespeichert werden.
     * Voraussetzung für die Nutzung dieser Methode ist, dass Der Layer mit seinem Schlüsselattribut
     * GDA-seitig in ExternalAppConfig.js registriert ist -> bei Rückfragen hierzu: Udo Keim oder init.
     **/
    const editGeometry = async function (layername, keysToEdit) {
        await openGDAPopup();
        sendGDARequestWhenReady(function () {
            gdaProxy.postMessage({
                action: "createOrEditObject",
                layerName: layername,
                keys: keysToEdit,
                persistObject: true,
            });
        });
    };

    /* Methode zum Highlighten einer Geometrie.
     * Die Geometrie wird auf dem Layer hervorgehoben, die überigen Geometrieb sind jedoch ebenfalls
     * sichtbar.
     * Voraussetzung für die Nutzung dieser Methode ist, dass Der Layer mit seinem Schlüsselattribut
     * GDA-seitig in ExternalAppConfig.js registriert ist -> bei Rückfragen hierzu: Udo Keim oder init.
     **/
    const highlightGeometry = async function (layername, keysToHighlight) {
        await openGDAPopup();

        sendGDARequestWhenReady(function () {
            gdaProxy.postMessage({
                action: "showKeys",
                layerName: layername,
                keys: keysToHighlight,
            });
        });
    };

    /* Methode zur Darstellung (Filterung) einer Geometrie auf einem Layer, z.B. um eine einzelne Kläranlage auf den Kläranlagen-Layer darzustellen.
     * Wichtig: für die Nutzung dieser Methode ist KEIN Eintrag in der ExternalAppConfig.js nötig!
     * Parameter:
     * - Layername: Name des Fachlayers auf den gefiltert werden soll
     * - FilterKey: Name des Attributs ( FeatureTypes), auf welchen gefitlert werden soll
     * - FitlerValues: Filterwerte (Schlüssel)
     * - Rechtswert/Hochwert: optionale Angabe zum Zoomen auf den Kartenausschnitt, insbes. bei Punktgeometrien
     * bei anderen Geometrien muss der Kartenausschnitt anderweitig ermittelt werden, es kann dann mittels "zoomKarte" ein Kartenausschnitt gezeigt werden.
     **/
    const filterObjektOnLayer = async function (layername, filterKey, filterValues, rechtswert, hochwert) {
        await openGDAPopup();

        sendGDARequestWhenReady(function () {
            gdaProxy.postMessage({
                action: "activateLayers",
                layerNames: [layername],
            });
        });

        sendGDARequestWhenReady(function () {
            gdaProxy.postMessage({
                action: "filterByKey",
                layerName: layername,
                filterKey: filterKey,
                filterValues: filterValues,
            });
        });

        //bei Angabe von rechtswert/Hochwert zusätzlich auf den Kartenausschnitt zoomen
        if (rechtswert != null && hochwert != null) {
            const boundingBox = [rechtswert - 100, hochwert - 30, rechtswert + 100, hochwert + 30];
            sendGDARequestWhenReady(function () {
                gdaProxy.postMessage({
                    action: "zoomTo",
                    obj: boundingBox,
                });
            });
        }
    };

    /* Methode zum Zoomen eines Kartenausschnitts */
    const zoomKarte = async function (boundingBox) {
        await openGDAPopup();

        if (boundingBox != null) {
            sendGDARequestWhenReady(function () {
                gdaProxy.postMessage({
                    action: "zoomTo",
                    obj: boundingBox,
                });
            });
        }
    };

    /* Prüdung, ob alle Konfigurationsparameter definiert wurden */
    function validateSettings() {
        if (typeof config.externalBaseUrl == "undefined") {
            alert(
                'Fehler GDA-Schnittstelle: Die Javascript Variable "externalBaseUrl" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen'
            );
            return false;
        }
        if (typeof config.externalApplicationId == "undefined") {
            alert(
                'Fehler GDA-Schnittstelle: Die Javascript Variable "externalApplicationId" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen'
            );
            return false;
        }
        if (typeof config.dspfUserId == "undefined") {
            alert(
                'Fehler GDA-Schnittstelle: Die Javascript Variable "dspfUserId" ist nicht definiert -> bitte auf der aufrufenden Seite einbauen'
            );
            return false;
        }
        return true;
    }

    /* Erzeugen eines Datascout-Tickets für den SSO-zugagn zu GDA, Hinzufügen als Javascript-Variable */
    async function loadDatascoutTicket(dspf_user_id, innerCallback) {
        const ticketURL = config.datascoutBaseURL + "/servlet/is/global." + dspf_user_id + ".generateTicket/?asJavascript=true";
        await jQuery.getScript(ticketURL, function () {
            logger.debug("dspfTicket: " + window.dspfTicket);
            innerCallback(window.dspfTicket);
        });
    }

    /* Öffnen eines GDA-Fensters (sofern noch nicht geöffnet) */
    const openGDAPopup = async function () {
        if (gdaProxy == null) await init();
        if (gdaPoupWindow == null || gdaPoupWindow.closed) {
            // this allows to open new windows if the popup was closed
            const externalBlankPageUrl = config.externalBaseUrl + "blank.html";
            gdaPoupWindow = window.open(externalBlankPageUrl, "mainapp", config.winOpts);
            gdaProxy.open("mainapp");
        }
        try {
            gdaPoupWindow.focus();
        } catch (e) {
            if (gdaPoupWindow === null) {
                config.confirm({
                    title: "Popup blockiert",
                    description: "Bitte erlauben sie Popup Fenster",
                });
            }
        }
    };

    /* Wrapper-Methode für alle XDM-Aufrufe an GDA Wasser. Die Aufrufe werden in einer Queue gepuffert,
     * bis GDA sich als betriebsbereit erklärt, und erst dann sukzessive aufgearbeitet */
    function sendGDARequestWhenReady(innerCallback) {
        //Funktionsaufruf zur Queue hinzufügen
        functionQueueWaitForReady.push(innerCallback);
        logger.debug("sendGDARequestWhenReady: function in queue aufgenommen: " + innerCallback);
        if (gisReadyTimer == null) {
            //wenn keine Timer -> Queueverarbeitung starten
            gisReadyTimer = setInterval(function () {
                if (gdaPoupWindow == null || gdaPoupWindow.closed) {
                    //wenn Fenster geschlossen -> Intervall abbrechen
                    //bei geschlossenem Fenster alles resetten
                    logger.debug("fenster geschlossen, lösche timer");
                    clearInterval(gisReadyTimer);
                    gisReadyTimer = null;
                    functionQueueWaitForReady = [];
                    return;
                }
                if (functionQueueWaitForReady.length === 0) {
                    //wenn alle Funktionen in der Queue abgearbeitet sind, Interval stoppen
                    logger.debug("queue abegearbeitet, lösche timer");
                    clearInterval(gisReadyTimer);
                    gisReadyTimer = null;
                    return;
                }
                //ansonsten immer weiter isGISReady feuern...
                gdaProxy.postMessage({action: "isGisReady"});
            }, 1000);
        }
    }

    /* Initialisierung der Schnittstelle zu GDA Wasser*/
    function initGDAClient(dspfTicket) {
        const externalRemoteHelperUrl = config.externalBaseUrl + "name.html";
        let externalRemoteUrl =
            config.externalBaseUrl +
            "remote.html?applicationId=" +
            config.externalApplicationId +
            "&dspf_user_id=" +
            config.dspfUserId +
            "&ticket=<ticket>";
        externalRemoteUrl = externalRemoteUrl.replace("<ticket>", encodeURIComponent(dspfTicket));
        easyXDM.DomHelper.requiresJSON("json2.js");
        //Initialisierung der GDA Verbindung
        gdaProxy = new easyXDM.Rpc(
            {
                remote: externalRemoteUrl,
                remoteHelper: externalRemoteHelperUrl,
            },
            {
                remote: {
                    open: {},
                    postMessage: {},
                },
                local: {
                    postMessage: function (data) {
                        if (data.isGisReady) {
                            //Antwort auf eine isGISReady-Anfrage: Funktion kann nun gefeuert werden
                            logger.debug("gda_client_api: GISReady recieved: " + data.isGisReady);
                            if (functionQueueWaitForReady.length > 0) {
                                //Queue-Function ausführen!
                                logger.debug("gda_client_api: calling function from Queue: " + functionQueueWaitForReady[0]);
                                const thisFunction = functionQueueWaitForReady.shift(); //Funktion aus Queue löschen
                                thisFunction(); //Funktion aus Queue ausführen
                                logger.debug("gda_client_api: verbleibende Funktionen in der Queue: " + functionQueueWaitForReady.length);
                            }
                        }

                        //Entgegennehmen einer Return-Koordinate
                        if (data.COORD) {
                            const ks = data.COORD.split(",");
                            if (ks.length === 2) {
                                config.recieveCoordinate(parseFloat(ks[0]).toFixed(1), parseFloat(ks[1]).toFixed(1));
                                gdaPoupWindow.close();
                            }
                        }
                    },
                },
            }
        );

        logger.debug("gda client initialized.");
    }

    /* Allgemeine Initialisierung */
    async function init() {
        if (gdaProxy != null) {
            isLoaded = true;
        }
        if (!isLoaded && validateSettings()) {
            //allgemeine Initialisierungen
            if (config.datascoutBaseURL != null && config.dspfUserId != null) {
                await loadDatascoutTicket(config.dspfUserId, initGDAClient);
            } else initGDAClient("");
        }
    }

    return {init, editCoordinate, zoomKarte, filterObjektOnLayer, highlightGeometry, editGeometry};
};

export default gdaClient;
